<!--
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：主页面入口
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
-->
<template>
	<div id="app" class="app">
		<!--
		<img alt="Vue logo" src="./assets/logo.png">
		<HelloWorld msg="Welcome to Your Vue.js App"/>
		<el-row>
			<el-button disabled>默认按钮</el-button>
			<el-button type="primary" disabled>主要按钮</el-button>
			<el-button type="success" disabled>成功按钮</el-button>
			<el-button type="info" disabled>信息按钮</el-button>
			<el-button type="warning" disabled>警告按钮</el-button>
			<el-button type="danger" disabled>危险按钮</el-button>
		</el-row>
		<div class="line"></div>
		-->
		<router-view></router-view>
	</div>
</template>
<script>
//import HelloWorld from './components/HelloWorld.vue'

// 输出元素，务必
export default {
	name: 'App',
	components: {
		//HelloWorld,
	},
	computed: {
	},
}
</script>

<style lang="less">
* {
	box-sizing: border-box;
}

html,body,h3,p {
	margin: 0;
	padding: 0;
}

body {
	/* min-height: 100vh; */
	background: linear-gradient(135deg, 
			#E9EEF3 0%,
			#E9EEF3 50%,
			#E9EEF3 100%);
	animation: gradientBG 15s ease infinite;
	display: flex;
	/* justify-content: center; */
	align-items: center;
	font-family: 'PingFang SC', system-ui, sans-serif;
	overflow: auto;
}

/*默认状态下样式*/
a { 
	color: #336699; 
	font-size: 15px; 
	text-decoration: none; 
	cursor:pointer; 
}

/* a 悬停状态下样式*/
/* a:hover { color: #ffffff; text-decoration: underline; font-weight: bold; background-color: #66bbff; border-radius: 7px; } */
/* a 悬停状态下样式 underline */
a:active { 
	color: #ff9933; 
	text-decoration: none; 
	font-weight: bold; 
	background-color:;
}

/* a 已浏览状态下样式*/
a:visited { 
	text-decoration: none; 
}

.app {
	/* font-family: Avenir, Helvetica, Arial, sans-serif; */
	font-family: 'Segoe UI', Tahoma, Geneva, Verdana, Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	margin-top: 0px;
	width: 100%;
	height: 100vh;
	display: flex;
	flex-direction: column;
}
</style>
